var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-email-sent.41000e81.png","uri@2x": __webpack_public_path__ + "icon-email-sent.227f3122.png","uri@3x": __webpack_public_path__ + "icon-email-sent.44d7ebfb.png",
    width: 232,
    height: 176
});